import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({   
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
      }
}))